<ng-container *ngIf="viewModel$ | async as viewModel">
  <pw-view-actions>
    <button mat-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
  </pw-view-actions>

  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      routerLink="/general/qr-code/{{ viewModel?.part?.OBJECT_ID }}">
      <span>QR-Code</span>
    </button>
  </mat-menu>

  <pw-view-title>{{ viewModel?.part?.TEXT }}</pw-view-title>

  <div class="p4m-grid-2-col">
    <mat-card>
      <mat-card-header>
        <mat-card-title
          >{{ 'general.infoPanels.part.general' | translate }}
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div
          style="display: grid; grid-template-columns: auto 1fr; grid-gap: 8px">
          <div style="font-weight: bold">
            {{ 'general.infoPanels.part.name' | translate }}
          </div>
          <div>{{ viewModel.part.NAME }}</div>
          <div style="font-weight: bold">
            {{ 'general.infoPanels.part.description' | translate }}
          </div>
          <div>{{ viewModel.part.DESCRIPTION }}</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title
          >{{ 'general.infoPanels.part.dies' | translate }}
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-nav-list>
          <mat-list-item
            *ngFor="let part of viewModel.children"
            (click)="rds.redirectToInfoPanel(part.OBJECT_ID)">
            <img matListItemAvatar [src]="part.ICON_URL" />
            <span
              matListItemLine
              style="word-wrap: anywhere; white-space: break-spaces"
              >{{ part.TEXT }}</span
            >
          </mat-list-item>
        </mat-nav-list>
      </mat-card-content>
    </mat-card>
  </div>
</ng-container>
